<div class="select-question" *ngIf="data.title !== undefined">
  <h5 [innerHTML]="data.title" *ngIf="data.title.length > 0"
      [ngClass]="{'default-text': !data.includeTitle}"></h5>
    <span class="select-layer" [ngClass]="{'disabled': !active}">
      <select class="app-select" [disabled]="!active"
              (change)="onAnswerSelected($event.target.value)">
        <option [value]="answer.id" *ngFor="let answer of data.answers"
                [selected]="answer.id === valueSelected">
          {{answer.value}}
        </option>
      </select>
    </span>
</div>
